if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

    // RESTAURANT MENUS FILTER
	document.querySelectorAll('.restMenusMod').forEach((mod) => {
		mod.querySelectorAll('.restMenusMod_nav-btn').forEach((btn) => {
			btn.addEventListener('click', () => {
				mod.querySelectorAll('.restMenusMod_nav-btn').forEach((b) => b.classList.remove('active'));
				btn.classList.add('active');

				mod.querySelectorAll('.restMenusMod_menu').forEach((menu) => menu.classList.remove('active'));
				mod.querySelector(`.restMenusMod_menu[data-id="${btn.dataset.id}"]`).classList.add('active');
			});
		});
	});

    if (document.querySelector('#pop-up-iframe iframe')) {
        let iframe = document.querySelector('#pop-up-iframe iframe'); 
        let popUp = document.querySelector('#pop-up-iframe');
        let close = document.querySelector('#pop-up-iframe .close'); 
        
        document.addEventListener("DOMContentLoaded", (event) => {
            setTimeout(() => {
                if (popUp) {
                    popUp.classList.add('active');
                }
            }, 5000);
        });
        if (close) {
            close.addEventListener('click', () => {
                popUp.classList.remove('active');
            });
        }
        
    }

})();